import { Modal } from 'react-bootstrap-v5';
import { IMemoriaCalculo } from '../../interfaces/IRelatorio';
import { Formatter, limitarTexto } from './Relatorio';

function RelatorioModal({ toggleModal, show, memoriasCalculo }: { toggleModal: () => void, show: boolean, memoriasCalculo: IMemoriaCalculo[] }) {

    const getPropertyNames =(value: IMemoriaCalculo) => {
        return Object.getOwnPropertyNames(value)
        .filter(p => p !== 'id' && p !== 'nomeArquivo' && p !== 'dataLancamento' && p !== 'dataRecolhimento' && p !== 'dataRecolhimentoString')
        .sort((a, b) => a === 'dataLancamentoString' ? -1 : 1);
    }

    return <Modal size='lg' centered={true} show={show} onHide={toggleModal}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title titulo-modal">Memória de cálculo</h5>
                <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                    <i onClick={toggleModal} className="fas fa-times" style={{ color: '#5E6397' }}></i>
                </div>
            </div>
            <div className="modal-body">
                {memoriasCalculo.length > 0 && (
                    <div className="col-md-12" style={{ marginTop: '2px'}}>
                        <p>Total Crédito: {memoriasCalculo.filter(x => x.tipo === 'C').map(x => x.valor).reduce((a, b) => a + b, 0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</p>
                        <p>Total Débito: {memoriasCalculo.filter(x => x.tipo === 'D').map(x => x.valor).reduce((a, b) => a + b, 0).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</p>
                    </div>
                )}
                <div className="col-md-12" style={{display: 'flex', padding: '5px'}}>
                    <div className="col-md-6"  style={{border: '1px solid #DFDFDF', borderRadius: '5px', marginRight: '3px', padding: '10px 15px'}}>
                        <label style={{ color: '#474A71', fontSize: '16px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>Registro do ECD</label>
                        {
                            memoriasCalculo.filter(x => x.tipo === 'D').length > 0 ?
                                memoriasCalculo.filter(x => x.tipo === 'D').map(x =>
                                    getPropertyNames(x).map((p, index) => 
                                        <div key={index} style={{padding: '10px 0'}}>
                                            {
                                                p === 'historico' ? 
                                                <button style={{color: '#EB1F44', fontSize: '14px', border: 'none', background: 'transparent' }} title={x.historico}>
                                                    {limitarTexto(x.historico, 20)}
                                                </button> :
                                                <label style={{color: '#EB1F44', fontSize: '14px' }}>
                                                    { 
                                                        p === "razaoSocial" ? 
                                                            limitarTexto(x.razaoSocial, 20) 
                                                        :
                                                            p === "valor" ? 
                                                                Formatter.format(x['valor'])
                                                            :
                                                                x[p as keyof IMemoriaCalculo]
                                                    }
                                                </label>   
                                            }
                                            <label style={{color: '#A3A3A3', float: 'right', fontSize: '14px'}}>
                                                {
                                                    limitarTexto(x.nomeArquivo, 10, 3)
                                                }
                                            </label>
                                        </div>
                                    )
                                )
                            : <p>Não há dados para serem exibidos</p>
                        }
                    </div>
                    <div className="col-md-6" style={{border: '1px solid #DFDFDF', borderRadius: '5px', marginLeft: '3px', padding: '10px 15px'}}>
                        <label style={{ color: '#474A71', fontSize: '16px', fontWeight: 'bold', marginBottom: '20px', textAlign: 'center' }}>Arquivos importados</label>
                        {
                            memoriasCalculo.filter(x => x.tipo === 'C').length > 0 ?
                                memoriasCalculo.filter(x => x.tipo === 'C').map(x =>
                                    getPropertyNames(x).map((p, index) => 
                                        <div key={index} style={{padding: '10px 0'}}>
                                            <label style={{ color: '#00B757', fontSize: '14px' }}>
                                                {
                                                    p === 'historico' ?
                                                        limitarTexto(x.historico, 30)
                                                    :
                                                    p === "razaoSocial" ? 
                                                        limitarTexto(x.razaoSocial, 20)
                                                    :
                                                        p === "valor" ? 
                                                            Formatter.format(x['valor'])
                                                        :
                                                        x[p as keyof IMemoriaCalculo]
                                                }
                                            </label>
                                            <label style={{ color: '#A3A3A3', float: 'right', fontSize: '14px' }}>
                                                {
                                                    limitarTexto(x.nomeArquivo, 10, 3)
                                                }
                                            </label>
                                        </div>
                                    )
                                )
                            : <p>Não há dados para serem exibidos</p>
                        }
                    </div>
                </div>
                    
            </div>
            <div className="modal-footer" style={{ margin: '0 auto' }}>
                <button onClick={toggleModal} type="button" className="btn btn-modal-cancelar me-5"> FECHAR </button>
            </div>
        </div>
    </Modal>
}

export default RelatorioModal;